export const available_device_versions = [
    {id: 1, name: "Version 1"},
    {id: 2, name: "Version 2"}
];